// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"TaskWorkflowActions-module__menuIcon--3iMgG","delete":"TaskWorkflowActions-module__delete--2Pss3"};